import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Select from "react-select";
import "../styles/ListagemClientes.css";

const ListagemLogs = () => {
  const navigate = useNavigate();

  const [clientes, setClientes] = useState([]);
  const [logs, setLogs] = useState([]);

  const [filtros, setFiltros] = useState({
    cliente_id: "",
    data_inicio: "",
    data_fim: ""
  });

  useEffect(() => {
    const buscarClientes = async () => {
      try {
        const response = await axios.get("/api/clientes");
        setClientes(response.data);
      } catch (error) {
        console.error("Erro ao buscar clientes:", error);
      }
    };

    buscarClientes();
  }, []);

  const handleFiltroChange = (e) => {
    const { name, value } = e.target;
    setFiltros((prevFiltros) => ({ ...prevFiltros, [name]: value }));
  };

  const handleClienteChange = async (selectedOption) => {
    const novoClienteId = selectedOption ? selectedOption.value : "";

    setFiltros((prevFiltros) => {
      const novosFiltros = { ...prevFiltros, cliente_id: novoClienteId };
      buscarLogsAtualizados(novosFiltros);
      return novosFiltros;
    });
  };

  const buscarLogsAtualizados = async (filtrosAtualizados) => {
    try {
      const queryParams = new URLSearchParams(
        Object.entries(filtrosAtualizados).filter(([_, v]) => v !== "")
      ).toString();

      const response = await axios.get(`/api/logs?${queryParams}`);
      setLogs(response.data);
    } catch (error) {
      console.error("Erro ao buscar logs:", error);
      alert("Erro ao buscar logs.");
    }
  };

  const handleBuscar = async () => {
    await buscarLogsAtualizados(filtros);
  };

  const handleLimpar = () => {
    setFiltros({ cliente_id: "", data_inicio: "", data_fim: "" });
    setLogs([]);
  };

  const agruparPorUsuario = (logs) => {
    const grupos = {};
    logs.forEach((log) => {
      const usuarioNome = log.usuario_nome || `Usuário ID ${log.usuario_id}`;
      if (!grupos[usuarioNome]) {
        grupos[usuarioNome] = [];
      }
      grupos[usuarioNome].push(log);
    });
    return grupos;
  };

  const formatarDataHora = (dataHora) => {
    if (!dataHora) return "";

    const [data, hora] = dataHora.split(' ');
    const [ano, mes, dia] = data.split('-');

    return `${dia}/${mes}/${ano} ${hora}`;
  };

  const logsAgrupados = logs && logs.length > 0 ? agruparPorUsuario(logs) : {};

  const opcoesClientes = clientes.map((cliente) => ({
    value: cliente.id,
    label: cliente.nome_fantasia || cliente.razao_social
  }));

  return (
    <div className="form-wrapper">
      <h2 className="form-title">Logs do Sistema</h2>

      <div className="filtros">
        <div style={{ minWidth: "250px" }}>
          <Select
            options={opcoesClientes}
            value={opcoesClientes.find(option => option.value === filtros.cliente_id)}
            onChange={handleClienteChange}
            placeholder="Selecione o Cliente"
            isClearable
            styles={{
              control: (provided) => ({
                ...provided,
                backgroundColor: "white",
                color: "black",
              }),
              menu: (provided) => ({
                ...provided,
                backgroundColor: "white",
                color: "black",
              }),
              option: (provided, state) => ({
                ...provided,
                backgroundColor: state.isFocused ? "#1976d2" : "white",
                color: "black",
              }),
              singleValue: (provided) => ({
                ...provided,
                color: "black",
              }),
              placeholder: (provided) => ({
                ...provided,
                color: "gray",
              }),
            }}
          />
        </div>

        <input
          type="date"
          name="data_inicio"
          value={filtros.data_inicio}
          onChange={handleFiltroChange}
        />

        <input
          type="date"
          name="data_fim"
          value={filtros.data_fim}
          onChange={handleFiltroChange}
        />

        <div className="acoes-filtro">
          <button onClick={handleBuscar}>🔍 Buscar</button>
          <button onClick={handleLimpar}>🧹 Limpar</button>
        </div>
      </div>

      {/* Tabela */}
      {Object.keys(logsAgrupados).length === 0 ? (
        <p>Nenhum log encontrado.</p>
      ) : (
        Object.entries(logsAgrupados).map(([usuarioNome, registros]) => (
          <div key={usuarioNome} style={{ marginBottom: "2rem" }}>
            <h3 style={{ marginTop: "2rem", color: "#1976d2" }}>{usuarioNome}</h3>

            <div className="table-responsive">
              <table className="tabela-clientes" style={{ fontSize: "0.65rem", marginLeft: "5px" }}>
                <thead>
                  <tr>
                    <th>Data/Hora</th>
                    <th>Tipo de Ação</th>
                    <th>Entidade</th>
                    <th>Descrição</th>
                  </tr>
                </thead>
                <tbody>
                  {registros.map((log) => (
                    <tr key={log.id}>
                      <td>{formatarDataHora(log.data_hora)}</td> {/* Agora formatado */}
                      <td>{log.tipo_acao}</td>
                      <td>{log.entidade}</td>
                      <td>{log.descricao}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ))
      )}

      <div className="form-actions">
        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => navigate(-1)}
        >
          Voltar
        </button>
      </div>
    </div>
  );
};

export default ListagemLogs;
